import { ErrorBoundary } from 'react-error-boundary';

import { cn } from 'lib/helpers/utility';

import ErrorMessage from '../ErrorMessage/ErrorMessage';

import { IconSvg } from './lib/Icon.generated';

import './lib/Icon.scss';

/**
 * @param {import('./lib/propTypes').IconProps} props
 */

const Icon = ({
  icon,
  size,
  className,
  color,
  shade = color === 'neutral' ? 700 : 500,
  fill = true,
  stroke = false,
  onClick,
  disabled = false,
  customColor,
  disableColor = false,
  ...rest
}) => {
  const handleClick = (e) => {
    if (disabled || typeof onClick !== 'function') return;
    e.stopPropagation();
    onClick();
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorMessage}>
      <div
        onClick={(e) => handleClick(e)}
        style={{
          ...(size && { width: size, minWidth: size }),
          ...(customColor && (stroke ? { stroke: customColor } : { fill: customColor })),
          ...(!onClick && { cursor: 'inherit' })
        }}
        className={cn(
          'Icon',
          `Icon--${icon}`,
          size && 'Icon--size',
          onClick && 'cursor-pointer',
          disabled && 'cursor-not-allowed opacity-50',
          fill && !disableColor && 'change-fill-color',
          stroke ? 'change-stroke-color' : !disableColor && 'change-fill-color',
          customColor && `Icon-color--${customColor}`,
          customColor && (stroke ? 'custom-stroke-color' : 'custom-fill-color'),
          color === 'white' || color === 'black' ? `Icon--${color}` : `Icon--${color}-${shade}`,
          className
        )}
        {...rest}>
        {IconSvg[icon]}
      </div>
    </ErrorBoundary>
  );
};

export default Icon;
